export enum NotificationLifeCycleEnum {
  new,
  read,
}
